import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputCombo from "../../helpers/InputCombo";

function Privilege(props)
{
    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [id, setId] = useState(props.row.id);

    const [row,setRow] = useState(null);


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);
    
        var req = {
            id: id
        };
    
        fetch( Config.url + '/rest_v1_access,privilege', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setRow(res.result);                          
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   
    
         return false;
    }
    

    const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {      
        
        var tmpRow = row;
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRow(  JSON.parse(JSON.stringify(tmpRow)) );              
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }



    const saveData = () => {
 
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    
        props.mainView.setProgress(-2);    

        fetch( Config.url + '/rest_v1_access,privilege_update', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                               
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 




        if(row == null)
        {
            setRow([]);
            getTab();             
            return <div>
                ...
            </div>
        }
    
    
    
        
    var itemsAct = [
        {
            v: 1,
            title: 'Może dodawać postów',
        },
        {
            v: 0,
            title: 'Nie może dodawać postów',
        },
    ]; 



    var itemsA = [
        {
            v: 1,
            title: 'Może dodawać',
        },
        {
            v: 0,
            title: 'Nie może dodawać',
        },
    ]; 



    var itemsB = [
        {
            v: 1,
            title: 'Widoczny na liście odbiorców',
        },
        {
            v: 0,
            title: 'Ukryty na liście odbiorców',
        },
    ]; 



    var itemsC = [
        {
            v: 1,
            title: 'Może zgłaszać',
        },
        {
            v: 0,
            title: 'Nie może zgłaszać',
        },
    ]; 


    var itemsD = [
        {
            v: 1,
            title: 'Aktywne',
        },
        {
            v: 0,
            title: 'Nieaktywne',
        },
    ]; 



    return <div className="view_content">
            
             <br/>
            <div className="calColor">Uprawnienia szczegółowe dla {row.nazwisko} {row.imie}</div>
            <br/>

            <form className="eForm bg_center">  

                   <div className="form_tab">

             
                                        
                                        <div className="form_control">
                                                <div className="fieldName">Moduł - aktualności</div>
                                                <InputCombo  items={itemsD}  userData={props.userData} value={row.upr_wglad_aktualnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_wglad_aktualnosci" placeholder={": "} className='  ' req='1' firstUp="1" />
                                        </div>

                                        {
                                            row.upr_wglad_aktualnosci == 1 &&
                                            <Fragment>
                                                    <div className="form_control">
                                                            <div className="fieldName">Aktualności</div>
                                                            <InputCombo  items={itemsAct}  userData={props.userData} value={row.upr_dodawanie_aktualnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_dodawanie_aktualnosci" placeholder={": "} className='  ' req='1' firstUp="1" />
                                                    </div>

                                                    <div className="form_control">
                                                            <div className="fieldName">Komentarze</div>
                                                            <InputCombo  items={itemsA}  userData={props.userData} value={row.upr_dodawanie_komentarzy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_dodawanie_komentarzy" placeholder={": "} className='  ' req='1' firstUp="1" />
                                                    </div>
                                            </Fragment>
                                        }                                      

                                        <div className="form_split"></div>

                                           
                                        <div className="form_control">
                                                <div className="fieldName">Moduł - korespondencja</div>
                                                <InputCombo  items={itemsD}  userData={props.userData} value={row.upr_wglad_korespondencja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_wglad_korespondencja" placeholder={": "} className='  ' req='1' firstUp="1" />
                                        </div>

                                        {
                                            row.upr_wglad_korespondencja == 1 &&
                                            <Fragment>
  
                                                    <div className="form_control">
                                                            <div className="fieldName">Lista odbiorców</div>
                                                            <InputCombo  items={itemsB}  userData={props.userData} value={row.upr_pisanie_z_rodzicami} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_pisanie_z_rodzicami" placeholder={": "} className='  ' req='1' firstUp="1" />
                                                    </div>

                                            </Fragment>
                                        }

                                                                                
                                        <div className="form_split"></div>

                                        <div className="form_control">
                                                <div className="fieldName">Nieobecności</div>
                                                <InputCombo  items={itemsC}  userData={props.userData} value={row.upr_zgl_nieobecnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="upr_zgl_nieobecnosci" placeholder={": "} className='  ' req='1' firstUp="1" />
                                        </div>

                                      



                    </div>

                    
                    <div className="form_split"></div>

                    <div className="form_btn">
                            <div className="btn" onClick={saveData}>zapisz</div>
                            &nbsp;&nbsp;
                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                    </div>


            </form>

    </div>
}


export default Privilege;